export default __webpack_public_path__ + "static/media/github.416e8876.svg";